/**
 * @group Functions
 * 
 * @summary
 * <blockquote>Get domain from a resource</blockquote>
 * 
 * @param resource - The resource name
 * @returns The domain extracted from the resource
 * 
 * @example
 * ```typescript
 * const domain = getDomainFromResource('db_users'); // 'users'
 * const domain2 = getDomainFromResource('actions.users'); // 'actions'
 * ```
 **/
export const getDomainFromResource = (resource: string): string => {
  // Remove db_ prefix if present
  if (resource.startsWith('db_')) {
    return resource.substring(3);
  }
  
  // Extract domain from dotted notation (e.g., 'actions.users' -> 'actions')
  return resource.split('.')[0];
}; 